import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const FreebieSuccess = () => {
    return (
            <Box sx={{ textAlign: 'center', bgcolor: "custom.red" }}>
                <Typography
                    variant="h4"
                    component="h1"
                    fontWeight={700}
                    
                    color="text.primary"
                    gutterBottom
                >
                    <em>SUCCESS! Your Freebie is on the way to your inbox 🎉</em>
                </Typography>
                <Typography
                    variant="body1"
                    fontSize={19}
                    
                    color="text.secondary"
                >
                    <em>(Please check your emails - spam and promotions tab too)</em>
                </Typography>
            </Box>
    );
};

export default FreebieSuccess;
